import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private _baseUrl : string = "";
  private _controllerName :string = "";

  constructor(private _http : HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = "Search"
  }

  // private getHeaders(): HttpHeaders{
  //   return new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${this.getToken()}`
  //   })
  // }

  getAll(term:string): Observable<any>{
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/?term=${term}`).pipe(catchError(this.handleErrors))
  }

  private handleErrors(error: HttpErrorResponse){
    if(error.error instanceof ErrorEvent){
      console.log("Ocurrio un error", error.error.message);
    }else{
      console.log(`Ocurrio un error ${error.status}, ${error.error}`);
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }
}
